import { Gauge, Mail, Phone, MapPin, Linkedin, Facebook } from "lucide-react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="theme-fixed-dark bg-[#141418] border-t border-[#2E2E33]" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
        <div>
          <div className="flex items-center gap-3 mb-5">
            <div className="w-10 h-10 border border-[#F59E0B] flex items-center justify-center bg-[#F59E0B]/10">
              <Gauge className="w-5 h-5 text-[#F59E0B]" strokeWidth={2.5} />
            </div>
            <div>
              <div className="font-heading font-black text-sm uppercase text-white">SGM México</div>
              <div className="font-mono text-[10px] text-[#A1A1AA] tracking-widest uppercase">Sector Hidrocarburos</div>
            </div>
          </div>
          <p className="text-[#A1A1AA] text-sm leading-relaxed">
            Soluciones de Gestión de Medición México. Cumplimiento técnico normativo ante CRE, CNH y SAT.
          </p>
        </div>

        <div>
          <div className="overline mb-5">Navegación</div>
          <ul className="space-y-3 text-sm">
            <li><a href="#inicio" className="text-[#A1A1AA] hover:text-[#F59E0B] transition-colors">Inicio</a></li>
            <li><a href="#sgm" className="text-[#A1A1AA] hover:text-[#F59E0B] transition-colors">¿Qué es el SGM?</a></li>
            <li><a href="#servicios" className="text-[#A1A1AA] hover:text-[#F59E0B] transition-colors">Servicios</a></li>
            <li><a href="#sectores" className="text-[#A1A1AA] hover:text-[#F59E0B] transition-colors">Sectores</a></li>
            <li><Link to="/login" className="text-[#A1A1AA] hover:text-[#F59E0B] transition-colors">Portal Clientes</Link></li>
          </ul>
        </div>

        <div>
          <div className="overline mb-5">Servicios</div>
          <ul className="space-y-3 text-sm text-[#A1A1AA]">
            <li>Conformación del SGM</li>
            <li>Póliza de Implementación</li>
            <li>Calibración y Verificación</li>
            <li>Auditorías de Cumplimiento</li>
            <li>Capacitación Especializada</li>
          </ul>
        </div>

        <div>
          <div className="overline mb-5">Contacto</div>
          <ul className="space-y-4 text-sm">
            <li className="flex items-start gap-3 text-[#A1A1AA]">
              <MapPin className="w-4 h-4 text-[#F59E0B] mt-0.5 flex-shrink-0" />
              <span>Av. Reforma 222, Cuauhtémoc<br/>Ciudad de México, CDMX</span>
            </li>
            <li className="flex items-center gap-3 text-[#A1A1AA]">
              <Phone className="w-4 h-4 text-[#F59E0B]" />
              <a href="tel:+525555555555" className="hover:text-white">+52 55 5555 5555</a>
            </li>
            <li className="flex items-center gap-3 text-[#A1A1AA]">
              <Mail className="w-4 h-4 text-[#F59E0B]" />
              <a href="mailto:contacto@sgmmexico.com" className="hover:text-white">contacto@sgmmexico.com</a>
            </li>
          </ul>
          <div className="flex items-center gap-3 mt-5">
            <a href="#" className="w-9 h-9 border border-[#2E2E33] flex items-center justify-center text-[#A1A1AA] hover:border-[#F59E0B] hover:text-[#F59E0B]">
              <Linkedin className="w-4 h-4" />
            </a>
            <a href="#" className="w-9 h-9 border border-[#2E2E33] flex items-center justify-center text-[#A1A1AA] hover:border-[#F59E0B] hover:text-[#F59E0B]">
              <Facebook className="w-4 h-4" />
            </a>
          </div>
        </div>
      </div>

      <div className="border-t border-[#2E2E33]">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-6 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-[#71717A] text-xs font-mono uppercase tracking-widest">
            © 2026 SGM México — Todos los derechos reservados
          </p>
          <p className="text-[#71717A] text-xs font-mono uppercase tracking-widest">
            RES/811 · RES/776 · CNH · SAT
          </p>
        </div>
      </div>
    </footer>
  );
}
